<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     用户名
  +---------------------------------------------------------------------------------------
-->
<template>
  <div>
    <el-link v-if="link" :underline="false" @click="toDetail">{{ title }}</el-link>
    <span v-else>{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: "FUserName",
  props: {
    user: {
      type: Object,
      default() {
        return {}
      },
    },

    type: {
      type: String,
      default: 'member' // member or user
    },

    link: {
      type: Boolean,
      default: true,
    },

  },

  data() {
    return {
    }
  },

  computed: {
    title() {
      return this.user.nickname || this.user.username || this.user.name || '未授权'
    }
  },

  methods: {
    toDetail() {
      const memberid = this.user.memberid || this.user.uid
      this.$memberdetail({memberid})
    },
  }
}
</script>
